// extracted by mini-css-extract-plugin
export default {"container":"mortgage-deal-supporting-doc_container__pd3Oj","marginTop":"mortgage-deal-supporting-doc_marginTop__Wl34Q"};